module.exports = __webpack_public_path__ + "static/media/schedule-pickup-home.2eeb5379.png";